import type { ReactNode } from "react";
import type {
    PickerItemData,
    PickerItemValue,
    PickerSectionData,
} from "@design-system/Picker/Picker.types";

/** The Filter popover tabs an Activity page can offer. */
export const ACTIVITY_FILTER_TAB_KEYS = {
    UPDATED_BY: "updated-by",
    UPDATED_THROUGH: "updated-through",
    ACTIVITY: "activity",
    ACTION: "action",
} as const;

type ActivityFilterRowList<T extends PickerItemValue> =
    | { items: ReadonlyArray<PickerItemData<T>>; sections?: never }
    | { sections: ReadonlyArray<PickerSectionData<T>>; items?: never };

/**
 * An Activity filter's rows and selection rules, which its Filter popover
 * panel and any dropdown of the same filter both render.
 */
export interface ActivityFilterRows<T extends PickerItemValue> {
    list: ActivityFilterRowList<T>;
    value: T[];
    onValueChange: (value: T[]) => void;
    onClear: () => void;
    /** The picks as text, as the chip and the dropdown trigger read them; none while nothing is picked. */
    chipLabel: string | undefined;
    /** Set with `onInputValueChange` when the hook matches the search itself and lists only matching rows. */
    filter?: (item: PickerItemData<T>, query: string) => boolean;
    onInputValueChange?: (query: string) => void;
}

/** One tab of an Activity page's Filter popover, and its chip while the filter is set. */
export interface ActivityFilterTab {
    key: string;
    label: string;
    icon: ReactNode;
    /** The chip's text; none while the filter is not set, which hides the chip. */
    chipLabel: string | undefined;
    panel: ReactNode;
    onClear: () => void;
}
